import { Typography, SxProps, Theme } from '@mui/material';

type Props = {
  title: string;
  sx?: SxProps<Theme>;
};

export default function DashboardTitle({ title, sx }: Props) {
  return <Typography sx={{ fontWeight: 'bold', fontSize: '1.25rem', ...sx }}>{title}</Typography>;
}
